import React from 'react';
import PropTypes from 'prop-types';
import { LocalForm, Control } from 'react-redux-form';
import { pageTypes } from './../helpers';
import SelectComponent from './SelectComponent';

import {
  FormGroup,
  Col,
  ControlLabel
} from 'react-bootstrap';

export default class PerformanceTypeSelectorComponent extends React.Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    pageType: PropTypes.object.isRequired,
    metricsDateInfo: PropTypes.object.isRequired,
  };

  performanceTypes = () => [
    pageTypes.PERFORMANCEMETRICS.type,
    pageTypes.EXPORTTESTS.type,
    pageTypes.CASEAMENDINGTESTS.type,
    pageTypes.CASEAMENDINGKPPTESTS.type,
    pageTypes.JOBBENCHMARK.type
  ];

  render() {
    const { onSubmit, pageType, metricsDateInfo } = this.props;

    const initialState = {
      timestamp: metricsDateInfo.timestamp,
      runCount: metricsDateInfo.runCount,
      performanceType: pageType.type ? pageType.type : ''
    };

    return (
      <div>
        <LocalForm
          id="performance-selector-form"
          model="performance"
          onChange={onSubmit}
          initialState={initialState}
        >
          <FormGroup>
            <Col md={5}>
              <ControlLabel>
                Performance Type:
              </ControlLabel>
              <Control.custom
                id="performance-input"
                model=".performanceType"
                component={SelectComponent}
                className="form-control"
                style={{ marginRight: '10px' }}
                mapProps={({ modelValue, onChange }) => {
                  return {
                    options: this.performanceTypes(),
                    noneOption: 'Select a Performance Type...',
                    selected: modelValue,
                    onChange: d => onChange(d)
                  };
                }}
              />
            </Col>
          </FormGroup>
        </LocalForm>
      </div>
    ); }
}


// WEBPACK FOOTER //
// src/Components/PerformanceTypeSelectorComponent.jsx